export default {
      id: "map-marker-alt-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#map-marker-alt",
      toString: function () {
        return this.url;
      }
    }